import { useParams } from "react-router";
import { EntityContextProvider } from "@emberly/zenith-client";
import MissionFormLayout from "./common/MissionFormLayout";
import MissionFormSettingsCard from "./cards/MissionFormSettingsCard";
import MissionFormLinkCard from "./cards/MissionFormLinkCard";

export default function MissionFormPage() {
  const { formId } = useParams();

  return (
    <EntityContextProvider id={formId} type="MissionForm">
      <MissionFormLayout >

        <MissionFormSettingsCard />

        <MissionFormLinkCard />

      </MissionFormLayout>
    </EntityContextProvider>
  );
}